import {forwardRef} from 'react';
import cx from 'classnames';
import Image from 'next/image';

import {Text} from '#component/base/Text';

import {AvatarProps} from './Avatar.types';

import {rootStyles, textStyles} from './Avatar.css';

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  ({className, image, size = 'medium', color, textSize, text, ...otherProps}, ref) => (
    <div className={cx(rootStyles({size, hasImage: !!image}), className)} ref={ref} {...otherProps}>
      {image ? (
        <Image src={image} alt={text} layout="fill" objectFit="cover" />
      ) : (
        <Text
          className={textStyles({size: textSize || size})}
          color={color ? color : 'paleOrange'}
          transform="uppercase">
          {text}
        </Text>
      )}
    </div>
  ),
);
